<template>
  <div class="cold-storage-monitor">
    <h3>Page under construction...</h3>     
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
 
onMounted(() => {
  console.log('冷库监测系统已启动')
})
</script>

<style scoped>
.cold-storage-monitor {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;  
  height: 100%;  
  padding: 15px;  
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  box-sizing: border-box;  
}
</style>

 